<template>
    <div>
        <div class="listingPageTitle">
            <h1>AI Transcription Maintenance</h1>
        </div>
        <div class="searchContainer">
            <div class="formRow"><span class="inputTitle">Search Name: </span><input type="text" v-model="searchText" /></div>
            <div class="formRow flexColumn"><span class="inputTitle">Status: </span>
                    <Multiselect style="width:250px"
                                v-model="searchStatus"
                                :options="statusCodes"
                                select-label=''
                                selected-label=''
                                deselect-label=''
                                placeholder="Type to search"
                                open-direction="bottom"
                                :multiple="true"
                                :searchable="true"></Multiselect>
                </div>
        </div>
        <hr />
        <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{ sortBy: 'id', sortDirection: 'desc'}" />
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ListingTable from '@/components/shared/ListingTable.vue';
import Multiselect from 'vue-multiselect';

export default {
    name: 'AiTranscriptionListing',
    components: { ListingTable, Multiselect },
    data() {
        return {
            searchText: '',
            componentKey: 0,
            searchStatus: [],
            statusCodes: ['submitted', 'processed'],
            columns: [
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Media Type",
                    width: "15%",
                    fieldName: "mediaPropertyMediaType"
                },
                {
                    headerDisplayName: "Media Description",
                    width: "40%",
                    fieldName: "mediaPropertyDescription"
                },
                {
                    headerDisplayName: "Transcription Status",
                    width: "15%",
                    fieldName: "statusCode"
                },
                {
                    headerDisplayName: "Last Modified",
                    width: "15%",
                    fieldName: "lastModifiedDateTime",
                    isDate: true
                },
                {
                    width: "5%",
                    columnType: "buttons",
                    showEditFieldName: "true"
                }
            ],
            actionMappings: {
                onLoadData: this.getData,
                editHrefBuilder: this.editHrefBuilder
            },
        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "mediaPropertyDescription",
                    value: this.searchText
                });
            
            if(this.searchStatus.length > 0)
                criteria.push( {
                    dataType: "String",
                    fieldName: "statusCode",
                    value: this.searchStatus
                });
            return criteria;
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData: async function() {
            let list = await data.getAllAITranscriptions();
            // Listing Table requires columns to exist on object's first layer
            list.forEach(ait => {
                ait.mediaPropertyMediaType = ait.mediaProperty.mediaType;
                ait.mediaPropertyDescription = ait.mediaProperty.description;
            });
            return list.filter(ait => ait.statusCode !== 'validated');
        },
        editHrefBuilder: function(ait) {
            return '/AITranscriptionEdit?ID=' + ait.id;
        },
    }
}
</script>
